import React, {
    useEffect,
    useState,
} from "react";

import {
    getSiteSettings,
    updateSiteSettings,
} from "../../services/adminApi";

import "./SiteSettings.css";


const SiteSettings = () => {

    const [form, setForm] = useState({
        site_name: "",
        site_title: "",
        site_description: "",
        site_keywords: "",
        email: "",
        phone: "",
        address: "",
        facebook: "",
        instagram: "",
        youtube: "",
        x: "",
        footer_text: "",
        maintenance_mode: false,
    });

    const [ogImage, setOgImage] =
        useState(null);

    const [favicon, setFavicon] =
        useState(null);

    const [settings, setSettings] =
        useState(null);

    const [loading, setLoading] =
        useState(true);

    const [saving, setSaving] =
        useState(false);

    const [message, setMessage] =
        useState("");

    const [error, setError] =
        useState("");


    useEffect(() => {

        const loadSettings =
            async () => {

                try {

                    setLoading(true);

                    const result =
                        await getSiteSettings();

                    const data =
                        result.data || {};

                    setSettings(data);

                    setForm({
                        site_name:
                            data.site_name || "",

                        site_title:
                            data.site_title || "",

                        site_description:
                            data.site_description || "",

                        site_keywords:
                            data.site_keywords || "",

                        email:
                            data.email || "",

                        phone:
                            data.phone || "",

                        address:
                            data.address || "",

                        facebook:
                            data.facebook || "",

                        instagram:
                            data.instagram || "",

                        youtube:
                            data.youtube || "",

                        x:
                            data.x || "",

                        footer_text:
                            data.footer_text || "",

                        maintenance_mode:
                            !!data.maintenance_mode,
                    });

                } catch (err) {

                    setError(
                        err.message ||
                        "Unable to load site settings."
                    );

                } finally {

                    setLoading(false);
                }
            };

        loadSettings();

    }, []);


    const handleChange = (e) => {

        const {
            name,
            value,
            type,
            checked,
        } = e.target;

        setForm((prev) => ({
            ...prev,

            [name]:
                type === "checkbox"
                    ? checked
                    : value,
        }));
    };


    const handleSubmit = async (
        e
    ) => {

        e.preventDefault();

        try {

           

            setSaving(true);
            setMessage("");
            setError("");

            const formData =
                new FormData();

            Object.entries(form)
                .forEach(
                    ([key, value]) => {

                        formData.append(
                            key,
                            value
                        );
                    }
                );


                

            if (ogImage) {
                formData.append(
                    "og_image",
                    ogImage
                );
            }

            if (favicon) {
                formData.append(
                    "favicon",
                    favicon
                );
            }


             

           
            const result =
                await updateSiteSettings(
                    formData
                );

                
                


            if (result.success) {

                setSettings(
                    result.data
                );

                setMessage(
                    "Site settings saved successfully."
                );


            } else {

                alert(result.message);



            }





            setOgImage(null);
            setFavicon(null);

        } catch (err) {

            setError(
                err.message ||
                "Unable to save settings."
            );

        } finally {

            setSaving(false);
        }
    };


    if (loading) {
        return (
            <section className="site-settings-page">
                <div className="settings-state">
                    Loading settings...
                </div>
            </section>
        );
    }


    return (
        <section className="site-settings-page">

            <div className="admin-page-header">

                <div>

                    <p className="admin-page-label">
                        SYSTEM
                    </p>

                    <h1>
                        Site Settings
                    </h1>

                    <p>
                        Manage the website's identity,
                        contact details, social media
                        and general configuration.
                    </p>

                </div>

            </div>


            {message && (
                <div className="settings-success">
                    {message}
                </div>
            )}

            {error && (
                <div className="settings-error">
                    {error}
                </div>
            )}


            <form
                className="settings-form"
                onSubmit={handleSubmit}
            >

                {/* IDENTITY */}

                <div className="settings-card">

                    <div className="settings-card-heading">

                        <span>
                            01
                        </span>

                        <div>
                            <h2>
                                Website Identity
                            </h2>

                            <p>
                                Basic information displayed
                                across the public website.
                            </p>
                        </div>

                    </div>


                    <div className="settings-fields">

                        <label>
                            Site Name

                            <input
                                name="site_name"
                                value={
                                    form.site_name
                                }
                                onChange={
                                    handleChange
                                }
                            />
                        </label>


                        <label>
                            Browser Title

                            <input
                                name="site_title"
                                value={
                                    form.site_title
                                }
                                onChange={
                                    handleChange
                                }
                            />
                        </label>


                        <label className="full">
                            Site Description

                            <textarea
                                name="site_description"
                                value={
                                    form.site_description
                                }
                                onChange={
                                    handleChange
                                }
                                rows="4"
                            />
                        </label>


                        <label className="full">
                            SEO Keywords

                            <input
                                name="site_keywords"
                                value={
                                    form.site_keywords
                                }
                                onChange={
                                    handleChange
                                }
                                placeholder="politician, Ekiti State, constituency, public service..."
                            />
                        </label>

                    </div>

                </div>


                {/* CONTACT */}

                <div className="settings-card">

                    <div className="settings-card-heading">

                        <span>
                            02
                        </span>

                        <div>
                            <h2>
                                Contact Information
                            </h2>

                            <p>
                                Official communication
                                details.
                            </p>
                        </div>

                    </div>


                    <div className="settings-fields">

                        <label>
                            Email Address

                            <input
                                type="email"
                                name="email"
                                value={
                                    form.email
                                }
                                onChange={
                                    handleChange
                                }
                            />
                        </label>


                        <label>
                            Phone Number

                            <input
                                name="phone"
                                value={
                                    form.phone
                                }
                                onChange={
                                    handleChange
                                }
                            />
                        </label>


                        <label className="full">
                            Office Address

                            <textarea
                                name="address"
                                value={
                                    form.address
                                }
                                onChange={
                                    handleChange
                                }
                                rows="3"
                            />
                        </label>

                    </div>

                </div>


                {/* SOCIAL */}

                <div className="settings-card">

                    <div className="settings-card-heading">

                        <span>
                            03
                        </span>

                        <div>
                            <h2>
                                Social Media
                            </h2>

                            <p>
                                Official social media
                                accounts.
                            </p>
                        </div>

                    </div>


                    <div className="settings-fields">

                        <label>
                            Facebook

                            <input
                                name="facebook"
                                value={
                                    form.facebook
                                }
                                onChange={
                                    handleChange
                                }
                                placeholder="https://facebook.com/..."
                            />
                        </label>


                        <label>
                            Instagram

                            <input
                                name="instagram"
                                value={
                                    form.instagram
                                }
                                onChange={
                                    handleChange
                                }
                                placeholder="https://instagram.com/..."
                            />
                        </label>


                        <label>
                            YouTube

                            <input
                                name="youtube"
                                value={
                                    form.youtube
                                }
                                onChange={
                                    handleChange
                                }
                                placeholder="https://youtube.com/..."
                            />
                        </label>


                        <label>
                            X / Twitter

                            <input
                                name="x"
                                value={
                                    form.x
                                }
                                onChange={
                                    handleChange
                                }
                                placeholder="https://x.com/..."
                            />
                        </label>

                    </div>

                </div>


                {/* BRANDING */}

                <div className="settings-card">

                    <div className="settings-card-heading">

                        <span>
                            04
                        </span>

                        <div>
                            <h2>
                                SEO &amp; Branding
                            </h2>

                            <p>
                                Search-engine and social
                                sharing assets.
                            </p>
                        </div>

                    </div>


                    <div className="settings-fields">

                        <label>
                            Open Graph Image

                            <input
                                type="file"
                                accept="image/jpeg,image/png,image/webp"
                                onChange={(e) =>
                                    setOgImage(
                                        e.target.files[0]
                                    )
                                }
                            />
                        </label>


                        <label>
                            Favicon

                            <input
                                type="file"
                                accept=".ico,.png,.svg"
                                onChange={(e) =>
                                    setFavicon(
                                        e.target.files[0]
                                    )
                                }
                            />
                        </label>

                    </div>

                </div>


                {/* GENERAL */}

                <div className="settings-card">

                    <div className="settings-card-heading">

                        <span>
                            05
                        </span>

                        <div>
                            <h2>
                                General
                            </h2>

                            <p>
                                General website behaviour.
                            </p>
                        </div>

                    </div>


                    <div className="settings-fields">

                        <label className="full">
                            Footer Text

                            <textarea
                                name="footer_text"
                                value={
                                    form.footer_text
                                }
                                onChange={
                                    handleChange
                                }
                                rows="3"
                            />
                        </label>


                        <label className="settings-switch">

                            <input
                                type="checkbox"
                                name="maintenance_mode"
                                checked={
                                    form.maintenance_mode
                                }
                                onChange={
                                    handleChange
                                }
                            />

                            <span>
                                Enable Maintenance Mode
                            </span>

                        </label>

                    </div>

                </div>


                <div className="settings-submit">

                    <button
                        type="submit"
                        className="admin-primary-button"
                        disabled={saving}
                    >
                        {saving
                            ? "Saving..."
                            : "Save Site Settings"}
                    </button>

                </div>

            </form>

        </section>
    );
};

export default SiteSettings;